import React from "react";
import { Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  Title,
  Plugin,
} from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend, Title);

const PieChart = ({ chartData }) => {
  const data = {
    labels: [
      `Company ${chartData?.totalCompanyInd || 0}`,
      `Site ${chartData?.totalSiteInd || 0}`,
    ],
    datasets: [
      {
        label: "Status",
        data: [
          Number(chartData?.totalCompanyInd || 0),
          Number(chartData?.totalSiteInd || 0),
        ],
        backgroundColor: [
          "#D2EBFF",
          "#0E4E9A",
        ],
        hoverOffset: 4,
        borderWidth: 0,
      },
    ],
  };

  const options = {
    responsive: true,

    plugins: {
      legend: {
        // display: true,
        position: "right",

        labels: {
          boxWidth: 10,
          padding: 20,
          borderWidth: 1,
          usePointStyle: true, // Add this line to make legend circles
        },
      },
    },
    cutout: "60%", // To make it a doughnut chart
  };

  // Custom plugin to draw text in the center
  const centerTextPlugin = {
    id: "centerText",
    beforeDraw: (chart) => {
      const {
        ctx,
        data,
        chartArea: { width, height },
      } = chart;
      ctx.save();
      // Convert data to numbers and calculate the total
      const total = data.datasets[0].data.reduce(
        (acc, value) => acc + Number(value),
        0
      );

      // Text settings for the total number
      ctx.font = "bold 20px Arial";
      ctx.fillStyle = "#1D2939";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";

      // Draw the total number
      ctx.fillText(`${total}`, width / 2, height / 2 - 10);

      // Text settings for "Total Checklists"
      ctx.font = "13px Arial"; // Regular font with 10px size
      ctx.fillText("Total Checklists", width / 2, height / 2 + 10);

      ctx.restore();
    },
  };

  return (
    <div
      className="card-body"  style={{width: '360px'}}
      // style={{ width: "100%", height: "400px" }}
    >
      <Doughnut data={data} options={options} plugins={[centerTextPlugin]} />
    </div>
  );
};

export default PieChart;
